import { makeAutoObservable, observable } from 'mobx';

import { queryFaqLevelConfig } from '@/api';

import store from '.';

/** 反馈来源选项类型 */
export interface FbSourceOption {
  label: string;
  value: number;
}

/**
 * FAQ绑定类型枚举
 */
export enum FaqBindTypeEnum {
  /** 没绑定 */
  None = 0,
  /** 智能分类 */
  IntelTag = 1,
  /** 用户分类 */
  LevelId = 3,
}

type BusinessState = {
  fbSourceOptions: FbSourceOption[];
  fbIntelOptions: IClassOption[];
  faqBindType: FaqBindTypeEnum | null;
  faqBindId: string;
  /** 在线日志的cosUrl,用于上标跳转打开日志 */
  cosUrl: string;
  /** 在线日志的搜索关键词，用于上标跳转正则匹配搜索 */
  keyword: string;
  /** 在线日志的搜索字段名称，用于上标跳转搜索 */
  fieldName: string;
  /** AI反馈未解决数量,用于智能客服会话列表展示 */
  feedbackAIUnSolvedCount: string;
};

export type BusinessStateKeys = keyof BusinessState;

/** 业务相关信息 STORE */
class BusinessStore {
  @observable public fbSourceOptions: FbSourceOption[] = [];
  @observable public fbIntelOptions: IClassOption[] = [];
  @observable public faqBindType: FaqBindTypeEnum = FaqBindTypeEnum.None;
  @observable public faqBindId: string = '';
  @observable public cosUrl: string = '';
  @observable public keyword: string = '';
  @observable public fieldName: string = '';
  @observable public feedbackAIUnSolvedCount: string = '0';

  public constructor() {
    makeAutoObservable(this);
  }

  /** 通用设置方法 */
  public setState<K extends BusinessStateKeys>(key: K, value: this[K]) {
    this[key] = value;
  }

  /** 批量设置方法 */
  public setStates<K extends keyof BusinessState>(
    states: Pick<BusinessState, K>
  ) {
    Object.entries(states).forEach(([key, value]) => {
      this.setState(key as K, value as this[K]);
    });
  }

  /**
   * 更新FAQ绑定信息
   * 将faqBindType重置为None，faqBindId重置为空字符串
   */
  public async handleUpdateFaqLevelConfig() {
    await queryFaqLevelConfig({ appId: store.appId }).then((res) => {
      this.setStates({
        faqBindType: res?.type || FaqBindTypeEnum.None,
        faqBindId: res?.id,
      });
    });
  }
}

/** 业务信息 STORE */
const BUSINESS_STORE = new BusinessStore();

export type TBusinessStore = typeof BUSINESS_STORE;

export default BUSINESS_STORE;
